import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Buttons from '../../core/Buttons';
import Icon from '../../core/Icon';
import ButtonPlus from '../../core/ButtonPlus';
import DropdownInput from '../../core/DropdownInput';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledSearchByDate = styled.div`
  position: relative;
  z-index: 2;
  ${mediaqueries.greaterThan('mobile')`
    display: flex;
    background-color: ${props => props.theme.colors.grayLighter};  
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width:${rem('558px')};
  `};
`;

const StyledDateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  overflow: hidden;
  background-color: ${props => props.theme.colors.grayLighter};
`;

const StyledDate = styled.time`
  background-color: ${props => props.theme.colors.graySad};
  color: ${props => props.theme.colors.light};
  display: flex;
  justify-content: center;
  min-width: ${rem('98px')};
  padding: ${rem('8px')} ${rem('10px')};
  ${mediaqueries.greaterThan('mobile')`
    align-items: center;
    min-width: ${rem('157px')};
    padding: 0;
    text-align: center;
  `};
`;

const StyledMonthDay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: ${rem('4px')};
  margin-top: ${rem('1px')};
  ${mediaqueries.greaterThan('mobile')`
      margin-top: 0;
  `};
`;

const StyledDay = styled.span`
  font-size: ${rem('28px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('38px')};
    line-height: ${rem('30px')};
  `};
`;

const StyledMonth = styled.strong`
  display: block;
  font: ${rem('11px')} ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('14px')};
  `};
`;

const StyledWeekDay = styled.span`
  font: ${rem('11px')} ${props => props.theme.fonts.book};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('13px')};
  `};
`;

const StyledButtondate = styled(Buttons)`
  padding: 0 ${rem('2px')} 0;
  ${mediaqueries.greaterThan('mobile')`
      display: none;  
  `};
`;

const StyledIconArrow = styled(Icon)`
  transform: rotate(270deg);
  ${props =>
    props.activeForm &&
    css`
      transform: rotate(90deg);
    `};
`;

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0 ${rem('14px')} ${rem('14px')} 0;
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
  background-color: ${props => props.theme.colors.grayLighter};
  ${props =>
    !props.activeForm
      ? css`
          opacity: 0;
          height: 0;
        `
      : css`
          opacity: 1;
          height: ${rem('112px')};
        `};
  ${mediaqueries.greaterThan('mobile')`
      display: flex;  
      flex-direction: row;  
      justify-content: flex-start;
      flex-grow: 1;
      max-width: 100%;
      /*padding: ${rem('17px')} ${rem('15px')} ${rem('17px')};*/
      opacity: 1;   
      height: ${rem('65px')};
      padding: 0 0 0 19px;
      align-items: center;
  `};
`;

const StyledButtonPlus = styled(ButtonPlus)`
  align-self: flex-end;
  ${mediaqueries.greaterThan('mobile')`
      height: ${rem('31px')};
      margin-left: ${rem('14px')};
      width: ${rem('31px')};
      align-self: center;
  `};
  ${mediaqueries.greaterThan('desktop')`
      height: ${rem('32px')};
      width: ${rem('32px')};
  `};
`;

const StyledWrapperDate = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: ${rem('15px')} 0;
  ${mediaqueries.greaterThan('mobile')`
      width: auto;
      padding: 0;
      align-items: center;
  `};
`;

const StyledWrapperDateSelector = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  ${mediaqueries.greaterThan('mobile')`
      width: auto;
      padding: 0;
      min-width: 320px;
  `};
`;

const commonStylesDropdown = `
  margin-left: ${rem('15px')};

  .drop-button {
    padding: ${rem('8px')} ${rem('10px')};
  }
`;

const StyledDropdownDay = styled(DropdownInput)`
  width: ${rem('62px')};

  .drop-button {
    padding: ${rem('8px')} ${rem('10px')};
  }
`;

const StyledDropdownMonth = styled(DropdownInput)`
  flex-grow: 1;
  max-width: ${rem('123px')};
  width: ${rem('98px')};
  ${commonStylesDropdown};
  ${mediaqueries.greaterThan('mobile')`
      width: ${rem('153px')};          
  `};
`;

const StyledDropdownYear = styled(DropdownInput)`
  width: ${rem('67px')};
  ${commonStylesDropdown};
  ${mediaqueries.greaterThan('mobile')`
      width: ${rem('97px')};          
  `};
`;

const StyledError = styled.p`
  color: ${props => props.theme.colors.error};
  font-size: ${rem('12px')};
  line-height: 1rem;
  margin: 0;
  position: absolute;
  bottom: ${rem('-16px')};
  right: 0;
  text-align: right;
  pointer-events: none;
`;

export {
  StyledSearchByDate,
  StyledDateWrapper,
  StyledDate,
  StyledMonthDay,
  StyledDay,
  StyledMonth,
  StyledWeekDay,
  StyledButtondate,
  StyledIconArrow,
  StyledForm,
  StyledButtonPlus,
  StyledWrapperDateSelector,
  StyledWrapperDate,
  StyledDropdownDay,
  StyledDropdownMonth,
  StyledDropdownYear,
  StyledError
};
